import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type { 
  TypeIdVerification, 
  TypeResponseIdVerification 
} from '@/shared/common/types/validateUserIdentity.type';

export const identityVerificationService = {
  /**
   * Crea una verificación de identidad con SEDPE.
   * @param data - Información de verificación de identidad con URLs de éxito y error.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<TypeResponseIdVerification>).
   */
  createIdVerification(data: TypeIdVerification): Promise<ApiResult<TypeResponseIdVerification>> {
    return executeRequest(() =>
      http.post<TypeResponseIdVerification>('company/b2b/identity-verification', data)
    );
  },
};
